import React from 'react';
import { connect } from 'react-redux'
import { _getToken, _error, _success, _validationFormMsg, _setAxios, _tableLogActivity, _getBase64, _getBase64Upload, _getBase64ImageUrl } from '../../../../lib/Helper';
import { schemaBerkas } from './schema';
import { Table, Row, Col, Divider, Popover, Modal, Button, Radio, Space, Dropdown, message, Upload, Alert } from 'antd';
import { PageHeader } from 'components/header';
import { Input, Tooltip } from 'antd';
import { DownloadOutlined, InfoCircleOutlined, SearchOutlined, ArrowUpOutlined, ArrowDownOutlined, PlusOutlined, SortAscendingOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined, InboxOutlined, DownCircleOutlined, SettingOutlined } from '@ant-design/icons';
import axios from 'axios';
import validate from 'validate.js';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const { Dragger } = Upload;

class Berkas extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tableOption: {
                sortField: "id",
                sortValue: "DESC",
            },
            data: [],
            search: "",
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: false,
            visibleModalCreate: false,
            id: 0,
            values: {},
            errors: {},
            create: {
                visible: false,
                loading: false,
            },
            update: {
                visible: false,
                loading: false,
                fileList: [],
                validateFile: false
            },
            delete: {
                loading: false,
            },
            dataID: this.props.dataID,
            ddl: {
                jenisBerkas: []
            },
            dataPersyaratan: []
        };
    }

    componentDidMount() {
        const { dataState } = this.props
        this.fetchTable()
        this.getJenisBerkasDDL()
        this.getJenisPersyaratanByJalurId(dataState?.dataDiri?.ppdb_jalur_id)
    }

    getJenisPersyaratanByJalurId = (jalurId) => {
        if (!jalurId) return

        _setAxios("ppdb/jenis-persyaratan/" + jalurId).then(resp => {
            if (resp.status === true) {
                this.setState({
                    dataPersyaratan: resp.data?.data,
                })
            }
        })
    }

    getJenisBerkasDDL = () => {
        _setAxios("ppdb/jenis-persyaratan", "POST", {
            "tipe": "Berkas"
        }).then(resp => {
            if (resp.status === true) {
                this.setState({
                    ddl: {
                        ...this.state.ddl,
                        jenisBerkas: resp.data.data
                    },
                })
            }
        })
    }

    fetchTable = () => {
        var params = {
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        }
        this.fetch(params);
    }


    handleTableChange = (pagination, filters, sorter) => {
        this.fetch({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
            search: this.state.search,
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        });
    };

    handleTableSearch = (e) => {
        const { value } = e.target;

        this.setState({
            search: value,
        });

        var params = {
            search: value,
            pagination: { ...this.state.pagination, current: 1 },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        }
        this.fetch(params);

    };

    handleTableFilter = e => {
        this.setState({
            tableOption: {
                ...this.state.tableOption,
                sortField: e.target.value
            },
        });

        this.fetch({
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: e.target.value,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        });
    };

    handleTableSort = e => {
        this.setState({
            tableOption: {
                ...this.state.tableOption,
                sortValue: e.target.value
            },
        });

        this.fetch({
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: e.target.value,
                urutan: 1,
            }]
        });
    };

    fetch = async (params = {}) => {
        this.setState({ loading: true });
        const headers = {
            'Accept': 'application/json',
            'Authorization': _getToken()
        };

        axios.post(process.env.REACT_APP_API_URL + '/ppdb/siswa/berkas/table/' + this.state.dataID, JSON.stringify(params), { headers })
            .then((resp) => {
                this.setState({
                    loading: false,
                    data: resp.data.list,
                    pagination: {
                        ...params.pagination,
                        total: resp.data.info.total,
                    },
                });
            })
            .catch(function (error) {
                if (error.response.data.message) {
                    _error('topRight', 'Failed', error.response.data.message)
                }
            });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setForm(name, value)
    };

    handleChangeSetValue = (name, value) => {
        this.setForm(name, value)
    };

    setForm = (name, value, row = {}) => {
        const { values } = this.state;
        values[name] = value;
        const errors = validate(values, schemaBerkas);
        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    resetForm = () => {
        this.setState({
            values: {},
            errors: {},
        });
    };

    beforeUploadFileBerkas = (file) => {
        const isJpgOrPngPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
        if (!isJpgOrPngPdf) {
            message.error('Anda bisa upload JPG/PNG/PDF file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('File tidak boleh lebih besar dari 2MB!');
        }

        const flag = isJpgOrPngPdf && isLt2M

        if (flag === false) {
            this.setState({
                update: {
                    ...this.state.update,
                    validateFile: false,
                }
            })
            return false
        } else {
            this.setState({
                update: {
                    ...this.state.update,
                    validateFile: true,
                }
            })
        }
        return true
    };

    handleChangeFileBerkas = ({ fileList }) => {
        if (this.state.update.validateFile === true) {
            fileList.forEach((row, i) => {
                fileList[i].status = "done"
            });

            this.setState({
                update: {
                    ...this.state.update,
                    fileList: fileList
                }
            })
        } else {
            this.setState({
                update: {
                    ...this.state.update,
                    fileList: null
                }
            })
        }
    };

    // CREATE START ------------------------------------------
    showModalCreate = () => {
        this.setState({
            create: {
                ...this.state.create,
                visible: true,
            },

        });
    };

    hideModalCreate = () => {
        this.setState({
            create: {
                visible: false,
                loading: false,
            },

        });
    };

    createSubmitBerkas = async (e) => {
        e.preventDefault();
        const { values } = this.state;
        const errors = validate(values, schemaBerkas);
        if (errors) {
            return _validationFormMsg(errors)
        }

        let file = null
        const fileList = this.state.update.fileList
        if (this.state.update.fileList.length > 0) {
            file = await _getBase64(fileList[0].originFileObj)
            file = _getBase64Upload(file)
        } else {
            message.warning("File tidak boleh kosong");
            return
        }

        const params = {
            "jenis_berkas_id": values.berkas_tipe ? values.berkas_tipe.id : null,
            "nama": values.berkas_nama ? values.berkas_nama : null,
            "keterangan": values.berkas_keterangan ? values.berkas_keterangan : null,
            "fileList": fileList,
            "file": file ? file : null,
        }

        this.setState({
            create: {
                ...this.state.create,
                loading: true
            }
        });

        _setAxios("ppdb/siswa/berkas/" + this.state.dataID, "POST", params).then(resp => {
            if (resp.status === true) {
                this.hideModalCreate()
                this.resetForm()
                this.fetchTable()
                _success('topRight', 'Success', resp.data.message)
            } else {
                this.setState({
                    create: {
                        ...this.state.create,
                        loading: false
                    }
                });
            }
        })
    };

    // CREATE END ------------------------------------------

    // UPDATE START ------------------------------------------
    showModalUpdate = (row) => {
        this.setState({
            update: {
                ...this.state.update,
                visible: true,
                loading: false,
                fileList: []
            },

            id: row.id,
            values: {
                berkas_tipe: {
                    id: row.jenis_berkas_id,
                    nama: row.jenis_berkas_nama,
                },
                berkas_nama: row.nama,
                berkas_keterangan: row.keterangan,
            },
        });
    };

    hideModalUpdate = () => {
        this.setState({
            update: {
                visible: false,
                loading: false
            }
        });
    };

    updateSubmitBerkas = async (e) => {
        e.preventDefault();
        const { values } = this.state;
        const errors = validate(values, schemaBerkas);
        if (errors) {
            return _validationFormMsg(errors)
        }

        var file = null
        const fileList = this.state.update.fileList
        if (this.state.update.fileList.length > 0) {
            if (fileList[0].url && (fileList[0].url.includes("https://") || fileList[0].url.includes("http://"))) {
                await _getBase64ImageUrl(fileList[0].url).then(dataUrl => {
                    file = _getBase64Upload(dataUrl)
                })
            } else {
                file = await _getBase64(fileList[0].originFileObj)
                file = _getBase64Upload(file)
            }
        }

        const params = {
            "jenis_berkas_id": values.berkas_tipe ? values.berkas_tipe.id : null,
            "nama": values.berkas_nama ? values.berkas_nama : null,
            "keterangan": values.berkas_keterangan ? values.berkas_keterangan : null,
            "fileList": fileList,
            "file": file ? file : null,
        }

        this.setState({
            update: {
                ...this.state.update,
                loading: true
            }
        });
        _setAxios("ppdb/siswa/berkas/" + this.state.id, "PUT", params).then(resp => {
            if (resp.status === true) {
                this.hideModalUpdate()
                this.resetForm()
                this.fetchTable()
                _success('topRight', 'Success', resp.data.message)
            } else {
                this.setState({
                    update: {
                        ...this.state.update,
                        loading: false
                    }
                });
            }
        })

    };
    // UPDATE END ------------------------------------------

    // DELETE START ------------------------------------------
    onDeleteSubmitBerkas = (row) => {
        Modal.confirm({
            title: 'Apakah Anda yakin?',
            icon: <ExclamationCircleOutlined />,
            content: 'Berkas [' + row.nama + '] akan dihapus dari list.',
            onOk: () => {
                this.setState({
                    delete: {
                        loading: true
                    }
                });

                _setAxios("ppdb/siswa/berkas/" + row.id, "DELETE").then(resp => {
                    if (resp.status === true) {
                        this.setState({
                            delete: {
                                loading: false
                            }
                        });
                        _success('topRight', 'Success', resp.data.message)
                        this.fetchTable()
                    } else {
                        this.setState({
                            delete: {
                                loading: false
                            }
                        });
                    }
                })
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    };

    // DELETE END ------------------------------------------


    render() {
        const action = this.props.action
        const { data, pagination, loading, values, errors, tableOption, ddl } = this.state;
        const { isOpen } = this.props.dataState;

        const sortComponent = <>
            <Radio.Group onChange={this.handleTableFilter} value={tableOption.sortField} name="sort_field">
                <Space direction="vertical">
                    <Radio value="nama">Nama</Radio>
                    <Radio value="id">Tanggal Pembuatan</Radio>
                </Space>
            </Radio.Group>

            <Divider orientation="left"></Divider>

            <Radio.Group onChange={this.handleTableSort} value={tableOption.sortValue} name="sort_value">
                <Space direction="vertical">
                    <Radio value="ASC"><ArrowUpOutlined /> Ascending</Radio>
                    <Radio value="DESC"><ArrowDownOutlined /> Descending</Radio>
                </Space>
            </Radio.Group>
        </>

        const formInput = <>
            <Row gutter={[24, 24]}>
                <Col xs={24}>
                    <Autocomplete
                        options={ddl.jenisBerkas}
                        value={values.berkas_tipe || null}
                        getOptionLabel={(option) =>
                            option.nama
                        }
                        onChange={(e, newValue) => {
                            this.handleChangeSetValue("berkas_tipe", newValue)
                        }}
                        name="berkas_tipe"
                        renderInput={(params) => <TextField {...params}
                            fullWidth
                            label="Jenis Berkas *"
                            size="small"
                            error={this.hasError('berkas_tipe')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            helperText={
                                this.hasError('berkas_tipe') ? errors.berkas_tipe[0] : null
                            }
                        />}
                    />
                </Col>
                <Col xs={24}>
                    <TextField
                        fullWidth
                        label={<>Nama Berkas * <span style={{ color: "rgb(189 182 182)", fontStyle: "italic" }}>(Pastikan yang dimasukkan adalah nama berkas)</span></>}
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="berkas_nama"
                        type="text"
                        onChange={this.handleChange}
                        value={values.berkas_nama || ""}
                        error={this.hasError('berkas_nama')}
                        helperText={
                            this.hasError('berkas_nama') ? errors.berkas_nama[0] : null
                        }
                    />
                </Col>
                <Col xs={24}>
                    <TextField
                        fullWidth
                        label="Keterangan"
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="berkas_keterangan"
                        type="text"
                        onChange={this.handleChange}
                        value={values.berkas_keterangan || ""}
                        error={this.hasError('berkas_keterangan')}
                        helperText={
                            this.hasError('berkas_keterangan') ? errors.berkas_keterangan[0] : null
                        }
                    />
                </Col>
                <Col xs={24}>
                    <Dragger
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        fileList={this.state.update.fileList}
                        onChange={this.handleChangeFileBerkas}
                        beforeUpload={this.beforeUploadFileBerkas}
                        maxCount={1}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Klik atau seret file ke area ini</p>
                        <p className="ant-upload-hint">
                            File yang diperbolehkan untuk diunggah: JPG, PNG & PDF
                        </p>
                        <p className="ant-upload-hint">
                            File yang diperbolehkan maksimal 2MB
                        </p>
                    </Dragger>
                </Col>
            </Row>
        </>

        const modalCreate = <Modal
            title="Tambah Berkas"
            visible={this.state.create.visible}
            onCancel={this.hideModalCreate}
            footer={<>
                <Button onClick={this.hideModalCreate}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.createSubmitBerkas} loading={this.state.create.loading}>Simpan</Button>
            </>}
        >
            <form autoComplete="off" onSubmit={this.createSubmitBerkas}>
                {formInput}
            </form>
        </Modal>

        const modalUpdate = <Modal
            title="Update Berkas"
            onCancel={this.hideModalUpdate}
            visible={this.state.update.visible}
            footer={<>
                <Button onClick={this.hideModalUpdate}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.updateSubmitBerkas} loading={this.state.update.loading}>Simpan</Button>
            </>}

        >
            <form autoComplete="off" onSubmit={this.updateSubmitBerkas}>
                {formInput}
            </form>
        </Modal>

        const modalDelete = <Modal
            title={<><ExclamationCircleOutlined /> Confirm</>}
            visible={this.state.delete.visible}
            onCancel={this.hideModalDelete}
            footer={<>
                <Button onClick={this.hideModalDelete}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.deleteSubmit} loading={this.state.delete.loading}>Simpan</Button>
            </>}
        >
            Apakah Anda Yakin?

        </Modal>

        return (
            <>
                <Alert
                    message="Info Penting"
                    description={<ul>{this.state.dataPersyaratan?.map((item, index) => {
                        return (
                            <li key={index}>{item.jenis_persyaratan_nama}</li>
                        )
                    })}</ul>}
                    type="warning"
                    showIcon
                />
                <Divider />
                <PageHeader
                    className="site-page-header"
                    title="Berkas"
                    extra={
                        action.file_create && isOpen ? <Button type='primary' className='nav-btn-page' icon={<PlusOutlined />} onClick={this.showModalCreate}> Tambah</Button> : ""
                    }
                />
                <Row gutter={[16, 16]}>
                    <Col xs={16} sm={18} md={20} lg={22}>
                        <Input
                            name="search"
                            className='search-table'
                            placeholder="Search..."
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            onChange={this.handleTableSearch}
                            value={this.state.search || ""}
                            suffix={
                                <Tooltip title="Cari berdasarkan nama">
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                    </Col>
                    <Col xs={8} sm={6} md={4} lg={2} className="text-align-right">
                        <Popover placement="bottom" content={sortComponent} trigger="click">
                            <Button block><SortAscendingOutlined /> Urutkan</Button>
                        </Popover>
                    </Col>
                </Row>

                <Divider orientation="left"></Divider>

                <Row>
                    <Col span={24}>
                        <Table
                            columns={[
                                {
                                    title: 'No',
                                    dataIndex: 'rownum',
                                    sorter: false,
                                    width: '3%',
                                }, {
                                    title: 'Jenis Berkas',
                                    dataIndex: 'jenis_berkas_nama',
                                    sorter: false,
                                }, {
                                    title: 'Nama',
                                    dataIndex: 'nama',
                                    sorter: false,
                                }, {
                                    title: 'Keterangan',
                                    dataIndex: 'keterangan',
                                    sorter: false,
                                }, {
                                    title: 'File',
                                    dataIndex: 'file',
                                    sorter: false,
                                    render: (a, row) => <a target="_blank" rel="noopener noreferrer" href={row.main_path + row.file} style={{ fontSize: 11 }}>Download <DownloadOutlined /></a>,
                                }, {
                                    title: <SettingOutlined />,
                                    align: "center",
                                    key: 'operation',
                                    width: '2%',
                                    render: (a, row) => isOpen && (action.file_update || action.file_delete) ? <Dropdown trigger={['click']} menu={{
  items: [...(action.file_update && isOpen === true ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.showModalUpdate.bind(this, row)
  }] : []), ...(action.file_delete && isOpen === true ? [{
    key: 1,
    icon: <DeleteOutlined />,
    label: "Delete",
    onClick: this.onDeleteSubmitBerkas.bind(this, row)
  }] : [])]
}}>
                                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                                    </Dropdown> : "-",
                                },
                                {
                                    title: 'LogActivity',
                                    key: 'operation',
                                    width: '10%',
                                    render: (a, row) => _tableLogActivity(row),
                                },
                            ]}
                            rowKey={record => record.id}
                            dataSource={data}
                            pagination={pagination}
                            loading={loading}
                            onChange={this.handleTableChange}
                            size="small"
                        />
                    </Col>
                </Row>

                {modalCreate}

                {modalUpdate}

                {modalDelete}

            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(Berkas);
